import React from 'react';
import ScrollTo from "../../lib/ScrollTo";
import clsx from "clsx";

// 2026 OK, Tailwind and camelCase, but still uses jquery
export default function ScrollToProductsButton({
  disabled = false,
  caption = "Select Options",
  icon = 'fa-arrow-down',
  className = "btn-primary w-full my-2 py-2"
}) {

  const handleClick = (evt) => {
    evt.preventDefault();

    const scroller = new ScrollTo($('#product-section'));     // FIXME jquery
    scroller.call();
  }

  return <button
    className={clsx(className)}
    onClick={handleClick}
    disabled={disabled}>
    {caption}
    <i className={`fa fa-lg mx-2 ${icon}`}/>
  </button>
}
